import * as yup from "yup";
import { ManualSubscriptionSimpleFormType } from "./form-type";

export const manualSubscriptionSimpleValidationSchema: yup.ObjectSchema<ManualSubscriptionSimpleFormType> = yup.object({
    userId: yup.number().required("User ID is required").positive("User ID must be a positive number"),
    activeTier: yup.string().optional(),
    hasSubscription: yup.boolean().optional(),
});
